$(function(){

    /**
     * main.js
     */

    /* Responsive embedded youtube/vimeo videos */
	// Find all YouTube/Vimeo videos
	var $allVideos = $("iframe[src*='//player.vimeo.com'], iframe[src*='//www.youtube.com']"),
    // The element that is fluid width
    $fluidEl = $(".whitebox_content, .confimationsub");
    // Figure out and save aspect ratio for each video
    $allVideos.each(function() {
        $(this)
        .data('aspectRatio', this.height / this.width)
            // and remove the hard coded width/height
            .removeAttr('height')
            .removeAttr('width');
    });
    // When the window is resized
    $(window).resize(function() {
        var newWidth = $fluidEl.width();
        // Resize all videos according to their own aspect ratio
        $allVideos.each(function() {
            var $el = $(this);
            $el
                .width(newWidth)
                .height(newWidth * $el.data('aspectRatio'));
        });
    // Kick off one resize to fix all videos on page load
    }).resize();


    /* BDC Reminder */
	// Trigger a Modal when the Reminder is activated
	var bdcReminder = $('#bdcReminder[data-show-after]');
	if( bdcReminder.length ) {
        // add bdc reminder cta target to fix scroll issue when OP_FORM shortcode is hidden, i.e. collapsed contact details
        $('[data-shortcode=op_form]').attr('id', 'bdcReminderTarget');

		var delay = $(bdcReminder).attr('data-show-after') * 1000;

		var bdcReminderTrigger = window.setInterval(function(){
			var isInViewport = false; // $('.homeform--op').is(':in-viewport');
			if( !isInViewport ) {
				bdcReminder.fadeIn();
				clearInterval(bdcReminderTrigger);
			}
		}, delay);

		// Events to close modal when click outside the modal, on a button or when the escape key is pressed
		$('.bdc__reminder__overlay').click(function(){ bdcReminder.hide(); });
		$('#bdcReminder button').on('click', function(){ bdcReminder.hide(); });
		$(document).keydown(function(e){ if(e.keyCode == 27) bdcReminder.hide(); });
    }

    // Remove invalid error for grouped gender radio button
    $('.radio-combined input').on('change', function(){
        $('.radio-combined').removeClass('error');
    });

    /* (mailcheck) */
    $('#freeOffer input[type=email], #ogForm input[type=email]').on('blur', function(event) {
        $('.suggestion').hide();
        $(this).mailcheck({
            // domains: ['hotmail.com', 'gmail.com', 'outlook.com', 'yahoo.com'],
            // topLevelDomains: ["com", "net", "org"],
            suggested: function(element, suggestion) {
                $('.suggestion i').text(suggestion.full);
                $('.suggestion').show();
                $('.suggestion').on('click', function(){
                    $('input[type=email]').val(suggestion.full);
                    $('.suggestion').hide();
                });
            }
        });
    });

    // Rename file name for PZD downloads
	$('a[download]').each(function(){
		var image = $(this).closest('[data-shortcode=pzd]').find('img');
		$(this).attr( 'download', $(image).attr('alt') + ($(this).attr('href')).match(/\.[0-9a-z]+$/i) )
	});

    /* Exclude some email providers (multi-step DE) */
    var multiStepEmailExcludeInfo = document.getElementsByClassName('ms_email_exclude_info')[0];
    if( multiStepEmailExcludeInfo ) {
        var multiStepEmailInput = document.querySelector('#ms_email');
        var MultiStepContainer = document.getElementsByClassName('ms_container')[0];
        multiStepEmailInput.addEventListener('input', function(){
            if( isEmailExcluded(this.value) ){
                multiStepEmailExcludeInfo.classList.add('show');
                MultiStepContainer.style.height = MultiStepContainer.offsetHeight + multiStepEmailExcludeInfo.offsetHeight + 'px';
            } else {
                MultiStepContainer.style.height = MultiStepContainer.offsetHeight - multiStepEmailExcludeInfo.offsetHeight + 'px';
                multiStepEmailExcludeInfo.classList.remove('show');
            }
        });
    }
    /* Exclude some email providers (og_form DE) */
    var emailExcludeInfo = document.getElementsByClassName('email_exclude_info')[0];
    if( emailExcludeInfo ) {
        var emailInput = document.querySelector('form input[type=email]');
        emailInput.addEventListener('input', function(){
            if( isEmailExcluded(this.value) ){
                emailExcludeInfo.classList.add('show');
            } else {
                emailExcludeInfo.classList.remove('show');
            }
        });
    }
    function isEmailExcluded(email) {
        /* @see https://stackoverflow.com/questions/26388648/email-validation-javascriptregex-but-to-exclude-certain-domains */
        var match = /^\w+[-\.\w]*@(\w+[-\.\w]*?\.\w{2,4})$/.exec(email);
        if (!match) return false;

        var forbiddenDomains = ["gmx.de", "gmx.com", "gmx.at", "gmx.net", "web.de"];
        if (forbiddenDomains.indexOf(match[1].toLowerCase()) >= 0) return true;

        return false;
    }

})
